"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DropdownDescription = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _createBorderCss = _interopRequireDefault(require("@oberoninternal/travelbase-ds/utils/createBorderCss"));
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _StyledCaret = _interopRequireDefault(require("./StyledCaret"));
var _useScrollIntoView = _interopRequireDefault(require("../../hooks/useScrollIntoView"));
var _dynamic = _interopRequireDefault(require("next/dynamic"));
var _theme = require("@oberoninternal/travelbase-ds/constants/theme");
const _excluded = ["as", "children", "surfaceElement", "initialFocusRef", "open", "dataCy", "onToggle", "borderRadius", "scrollIntoView", "modifiers", "popupPlacement"];
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Manager = (0, _dynamic.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require('react-popper'))).then(mod => mod.Manager), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak('react-popper')]
  }
});
const Reference = (0, _dynamic.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require('react-popper'))).then(mod => mod.Reference), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak('react-popper')]
  }
});
const Popper = (0, _dynamic.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require('react-popper'))).then(mod => mod.Popper), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [require.resolveWeak('react-popper')]
  }
});
const Dropdown = /*#__PURE__*/(0, _react.forwardRef)((_ref, containerRef) => {
  let {
      as,
      children,
      surfaceElement,
      initialFocusRef,
      open,
      dataCy,
      onToggle,
      borderRadius,
      scrollIntoView,
      modifiers,
      popupPlacement
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const {
    0: hasFocus,
    1: setHasFocus
  } = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (open && !hasFocus) {
      if (initialFocusRef?.current) {
        initialFocusRef.current.focus();
      }
    }
    if (!open) {
      setHasFocus(false);
    }
  }, [open, hasFocus, initialFocusRef]);
  const contentRef = (0, _react.useRef)(null);
  (0, _useScrollIntoView.default)(contentRef, scrollIntoView && open, false, {
    block: 'nearest'
  });
  const updateRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    updateRef.current?.();
  }, [open]);
  return __jsx(Container, (0, _extends2.default)({}, props, {
    ref: containerRef,
    "data-cy": dataCy,
    borderRadius: borderRadius
  }), __jsx(Manager, null, __jsx(Reference, null, ({
    ref
  }) => __jsx(Button, {
    ref: ref,
    onClick: onToggle,
    "aria-expanded": open,
    as: as ?? 'button',
    open: open,
    type: "button"
  }, surfaceElement, __jsx(StyledDropdownIcon, null))), __jsx(Popper, {
    modifiers: _objectSpread({
      offset: {
        offset: '0, 10'
      }
    }, modifiers),
    placement: popupPlacement ?? 'bottom-start'
  }, ({
    ref,
    style,
    placement,
    scheduleUpdate
  }) => {
    updateRef.current = scheduleUpdate;
    return __jsx(ContentWrapper, {
      ref: ref,
      style: style,
      "data-placement": placement,
      placement: placement,
      open: open
    }, __jsx(Content, {
      open: open,
      tabIndex: 0,
      ref: contentRef
    }, children));
  })));
});
var _default = exports.default = Dropdown;
const ContentWrapper = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "Dropdown__ContentWrapper",
  componentId: "xsjgsz-0"
})(["z-index:", ";"], ({
  theme
}) => theme.zIndices.dropdown);
const Container = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "Dropdown__Container",
  componentId: "xsjgsz-1"
})(["position:relative;z-index:3;--surfaceHeight:4.8rem;height:var(--surfaceHeight);--borderRadius:", ";svg{flex-shrink:0;}"], ({
  theme,
  borderRadius
}) => borderRadius ?? theme.radius.textInput);
const DropdownDescription = exports.DropdownDescription = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "Dropdown__DropdownDescription",
  componentId: "xsjgsz-2"
})(["text-align:start;display:-webkit-box;-webkit-line-clamp:1;text-overflow:ellipsis;-webkit-box-orient:vertical;overflow:hidden;"]);
const StyledDropdownIcon = (0, _styledComponents.default)(_StyledCaret.default).withConfig({
  displayName: "Dropdown__StyledDropdownIcon",
  componentId: "xsjgsz-3"
})(["margin-left:auto;"]);
const Button = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "Dropdown__Button",
  componentId: "xsjgsz-4"
})(["background:", ";--border-color:", ";", " height:var(--surfaceHeight);padding:0 ", ";display:flex;align-items:center;outline:none;width:100%;position:absolute;left:0;top:0;color:", ";z-index:3;border-radius:var(--borderRadius);", "{color:", ";}", ";:hover{--border-color:", ";box-shadow:0 0 0 1px var(--border-color),inset 0 0 0 0.5px var(--border-color);}:focus{border-color:transparent;--border-color:", ";color:", ";}transition:box-shadow 0.15s ease-in-out,color 0.3s ease-in;"], ({
  theme
}) => theme.colors.neutral['0'], ({
  theme
}) => theme.colors.neutral['20'], (0, _createBorderCss.default)('1px'), ({
  theme
}) => theme.spacing['40_Standard'], ({
  theme
}) => theme.colors.neutral['80'], StyledDropdownIcon, ({
  theme
}) => theme.colors.neutral['40'], ({
  open
}) => open && (0, _styledComponents.css)(["--border-color:", ";box-shadow:0 0 0 1px var(--border-color),inset 0 0 0 0.5px var(--border-color);", "{color:", ";}"], ({
  theme
}) => (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input), StyledDropdownIcon, ({
  theme
}) => theme.colors.neutral['90']), ({
  theme,
  open
}) => open ? theme.colors.neutral['90'] : theme.colors.neutral['40'], ({
  theme
}) => (0, _theme.getAssignmentColor)(theme, theme.colorAssignments.input), ({
  theme
}) => theme.colors.neutral['90']);
const Content = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "Dropdown__Content",
  componentId: "xsjgsz-5"
})(["@media screen and (max-width:", "px){min-width:80vw;}background:", ";outline:none;border-radius:", ";top:var(--surfaceHeight);:focus{::before{--border-color:grey;", ";}}box-shadow:0 0 40px 0 rgba(16,36,48,0.1);", ";"], ({
  theme
}) => theme.mediaQueriesValues.xs, ({
  theme
}) => theme.colors.neutral['0'], ({
  theme
}) => theme.radius.dropdown, (0, _createBorderCss.default)('1px'), ({
  open
}) => !open && (0, _styledComponents.css)(["display:none;"]));